import { create } from 'apisauce';

export const getShareUrl = async (body, weddingId) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/wedding/${weddingId}/design/share/url`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'x-Requested-with': 'XMLHttpRequest',
    },
  });
  const response = await api.post('', body);
  const { data, status } = response;
  if (status === 200) {
    return data;
  }
  return { error: 'Something went wrong.' };
};
